import Login from './page/Login.vue'
import Nav from './page/Nav.vue'
import Home from './page/Home.vue'
import Center from './page/Center.vue'

//后台管理
import AdminCount from './page/admin/count.vue';  //首页
import AdminIndex from './page/admin/index.vue';  //首页
import AdminUser from './page/admin/user.vue';  //账号管理
import AdminExpert from './page/admin/expert.vue';//专家管理
import AdminExpertGroup from './page/admin/expertgroup.vue';//操作日志
import AdminRule from './page/admin/rule.vue';//项目评分规则
import AdminForm from './page/admin/form.vue';//形式审查项目
import AdminData from './page/admin/data.vue';//资料评审项目
import AdminScene from './page/admin/scene.vue';//现场评审项目
import AdminComment from './page/admin/comment.vue';//点评项目
import AdminCompleted from './page/admin/completed.vue';//完成项目
import AdminCollect from './page/admin/collect.vue';//信息收集
import AdminConfig from './page/admin/config.vue';//全局配置
import AdminSys from './page/admin/system.vue';//系统管理
import AdminMenu from './page/admin/menu.vue';//菜单管理
import AdminRole from './page/admin/role.vue';//角色配置
import AdminLog from './page/admin/log.vue';//操作日志
import AdminUserLog from './page/admin/userLog.vue';//操作日志
//模板
import ModelIndex from './page/model/index.vue';//首页
import ModelPro from './page/model/project.vue';//项目列表

//专家系统
import ExpertIndex from './page/expert/index.vue';//首页
import ExpertData from './page/expert/data.vue';//资料评审项目
import ExpertScene from './page/expert/scene.vue';//现场评审项目
import ExpertComment from './page/expert/comment.vue';//点评项目

//移动专家审核
import MobileLogin from './page/mobile/login.vue';//登录
import MobileSystem from './page/mobile/system.vue';//
import MobileList from './page/mobile/list.vue';//
import MobileExpert from './page/mobile/expert.vue';//
import Signature from './page/mobile/signature.vue';//
let routes = [
    {
        path: '/login',
        component: Login,
        name: 'user',
    },
    {
        path: '/AdminLogin',
        component: Login,
        name: 'amdin',
    },
    {
        path: '/nav',
        component: Nav,
        name: '',
    },
    {
        path: '/Center',
        component: Center,
        name: '',
    },
    {
        path: '/admin',
        component: Home,
        name: '',
        children: [
            { path: '/AdminCount', component: AdminCount, name: '项目统计' },
            { path: '/AdminIndex', component: AdminIndex, name: '管理员账号列表' },
            { path: '/AdminUser', component: AdminUser, name: '用户账号管理' },
            { path: '/AdminExpert', component: AdminExpert, name: '专家管理' },
            { path: '/AdminExpertGroup', component: AdminExpertGroup, name: '专家分组管理' },
            { path: '/AdminRule', component: AdminRule, name: '项目评分规则' },
            { path: '/AdminForm', component: AdminForm, name: '形式审查项目' },
            { path: '/AdminData', component: AdminData, name: '资料评审项目' },
            { path: '/AdminScene', component: AdminScene, name: '现场评审项目' },
            { path: '/AdminComment', component: AdminComment, name: '点评项目' },
            { path: '/AdminCompleted', component: AdminCompleted, name: '完成项目' },
            { path: '/AdminCollect', component: AdminCollect, name: '信息收集' },
            { path: '/AdminConfig', component: AdminConfig, name: '全局配置' },
            { path: '/AdminSys', component: AdminSys, name: '评审系统管理' },
            { path: '/AdminRole', component: AdminRole, name: '角色管理' },
            { path: '/AdminMenu', component: AdminMenu, name: '菜单管理' },
            { path: '/AdminLog', component: AdminLog, name: '后台操作日志' },
            { path: '/AdminUserLog', component: AdminUserLog, name: '前台操作日志' },
        ]
    },
    {
        path: '/model',
        component: Home,
        name: '',
        children: [
            { path: '/ModelIndex', component: ModelIndex, name: '首页',icon:"icon-shouye"},
            { path: '/ModelPro', component: ModelPro, name: '项目列表',icon:"icon-renwu"},
        ]
    },
    {
        path: '/expert',
        component: Home,
        name: '',
        children: [
            { path: '/ExpertIndex', component: ExpertIndex, name: '首页',icon:"icon-shouye"},
            { path: '/ExpertData', component: ExpertData, name: '资料评审项目',icon:"icon-shenhe"},
            { path: '/ExpertScene', component: ExpertScene, name: '现场评审项目',icon:"icon-shenhe"},
            { path: '/ExpertComment', component: ExpertComment, name: '点评项目',icon:"icon-shenhe"},
        ]
    },
    {
        path: '/MobileLogin',
        component: MobileLogin,
        name: 'expert',
    },
    {
        path: '/MobileExpert/:id/:type',
        component: MobileExpert,
        name: 'expert',
    },
    {
        path: '/MobileList',
        component: MobileList,
        name: 'expert',
    },
    {
        path: '/MobileSystem',
        component: MobileSystem,
        name: 'expert',
    },
    {
        path: '/Signature/:id',
        component: Signature,
        name: 'expert',
    },
];

export default routes;